import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "36",
  height: "36",
  viewBox: "0 0 36 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M16 3.5V21.5H4V3.5H16Z",
  stroke: "#121926",
  "stroke-width": "2"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M20 32.5L20 14.5L32 14.5L32 32.5L20 32.5Z",
  stroke: "#121926",
  "stroke-width": "2"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M16 25.5V32.5H4V25.5H16Z",
  stroke: "#121926",
  "stroke-width": "2"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  d: "M20 10.5L20 3.5L32 3.5L32 10.5L20 10.5Z",
  stroke: "#121926",
  "stroke-width": "2"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }